import React, { FC } from 'react';
import MenuSectionsSidebar from './MenuSectionsSidebar';
import MenuSectionsMobile from './MenuSectionsMobile';
import { useScreenSize } from '../../../context/ScreenSizeContext';
import { MenuSectionDto } from '../../../../generated-api';

interface Props {
  menuSections: MenuSectionDto[];
  selectedSectionId?: string;
  onSectionSelected: (sectionId: string) => void;
  overflowRef?: React.RefObject<HTMLDivElement>;
  showOverflowIcon?: boolean;
  onOverflowIconClick: () => void;
  isExpanded?: boolean;
}

const MenuSections: FC<Props> = ({
  menuSections,
  onSectionSelected,
  selectedSectionId,
  overflowRef,
  showOverflowIcon,
  onOverflowIconClick,
  isExpanded,
}) => {
  const { isPhone } = useScreenSize();

  return (
    <>
      {isPhone ? (
        <MenuSectionsMobile
          menuSections={menuSections}
          onSectionSelected={onSectionSelected}
          selectedSectionId={selectedSectionId}
          overflowRef={overflowRef}
          showOverflowIcon={showOverflowIcon}
          onOverflowIconClick={onOverflowIconClick}
          isExpanded={isExpanded}
        />
      ) : (
        <MenuSectionsSidebar
          menuSections={menuSections}
          onSectionSelected={onSectionSelected}
          selectedSectionId={selectedSectionId}
        />
      )}
    </>
  );
};
export default MenuSections;
